var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 354,
    viewBox: "0 0 350 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7482 157.624C54.4114 85.1617 121.798 35.0633 194.261 45.7265C218.984 49.3644 242.176 59.9134 261.165 76.1582L244.071 93.2524C238.341 98.9833 238.343 108.274 244.074 114.004C246.825 116.754 250.555 118.299 254.445 118.3H321.738C329.841 118.3 336.411 111.731 336.411 103.627V36.3344C336.409 28.2306 329.838 21.6626 321.734 21.664C317.845 21.6647 314.114 23.2102 311.363 25.9601L292.287 45.0353C219.543 -19.8084 108.006 -13.4049 43.1621 59.3383C20.1898 85.1087 5.28202 117.052 0.285715 151.212C-1.68419 163.322 6.5359 174.736 18.6456 176.706C19.7365 176.884 20.8384 176.979 21.9437 176.993C33.023 176.873 42.323 168.612 43.7482 157.624Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328.055 176.991C316.976 177.11 307.676 185.372 306.251 196.36C295.588 268.822 228.201 318.92 155.738 308.258C131.015 304.62 107.823 294.071 88.8342 277.826L105.929 260.732C111.658 255.001 111.657 245.71 105.925 239.981C103.175 237.231 99.4438 235.685 95.5542 235.685H28.263C20.1592 235.685 13.5898 242.254 13.5898 250.358V317.65C13.5919 325.754 20.1626 332.322 28.2665 332.32C32.1561 332.319 35.8868 330.774 38.6374 328.024L57.7126 308.949C130.439 373.799 241.968 367.416 306.819 294.689C329.804 268.913 344.719 236.959 349.713 202.787C351.692 190.678 343.479 179.258 331.371 177.28C330.274 177.101 329.166 177.004 328.055 176.991Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.82a60814dc8131dfe8020ebe8b09bbd7.svg";
export { ForwardRef as ReactComponent };